import { FormGroup } from '@mui/material'
import { FieldArray, FieldArrayRenderProps } from 'formik'
import { useTranslationData } from '../../../../../contexts'
import { ContactInformationRelease } from '../../../../../utils/classes/graphql'
import { OwnInfoCheckBox } from './owninfo-checkbox'

export const InformationReleases = () => {
  const { UILanguage } = useTranslationData()

  const getInformationReleaseLabel = (
    infoRelease: ContactInformationRelease
  ) => {
    if (UILanguage === 'fi') {
      return infoRelease.kohde
    } else if (UILanguage === 'en') {
      return infoRelease.kohde_en
    } else if (UILanguage === 'sv') {
      return infoRelease.kohde_sv
    }
  }

  return (
    <FormGroup>
      <FieldArray
        name="luvat"
        render={(arrayHelpers: FieldArrayRenderProps) =>
          arrayHelpers.form.values.luvat?.map(
            (infoRelease: ContactInformationRelease, index: number) => (
              <OwnInfoCheckBox
                key={`user-informationRelease-${index}-${infoRelease?.kohdeKoodi}`}
                label={getInformationReleaseLabel(infoRelease) || undefined}
                name={`luvat.${index}`}
              />
            )
          )
        }
      />
    </FormGroup>
  )
}
